module.exports = __webpack_public_path__ + "4ca3e5f3e384c68dd0154861caa28d6f.svg";